import { ContentMethodEmbed, ContentMethodRichText } from "../../manage/methods"

export default {
  EMBED: {
    key: "AssessmentEmbed",
    fieldsData: {
      code: {
        placeholder: "Paste embed code to assessment",
        action_prompt: "Load assessment"
      }
    },
    getValues(content) {
      const values = {
        code: content != null ? content.content_embed_code : undefined
      }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = { content_embed_code: fieldsData.code.value }
      return saveData
    },
    renderForm({ fieldsData }) {
      return (
        <ContentMethodEmbed
          defaultMode="embed_code"
          codeProps={fieldsData.code}
          allowToggle={false}
        />
      )
    }
  },

  LISTED: {
    key: "AssessmentListed",
    fieldsData: {
      richtext: {
        placeholder: "Assessment instructions..."
      }
    },
    getValues(content) {
      const values = {
        richtext:
          (content != null ? content.listed_instructions : undefined) ||
          __guard__(
            content != null ? content.assessment : undefined,
            (x) => x.listed_instructions
          )
      }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = { listed_instructions: fieldsData.richtext.value }
      return saveData
    },
    renderForm({ fieldsData }) {
      return (
        <ContentMethodRichText {...Object.assign({}, fieldsData.richtext)} />
      )
    }
  }
}

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
